import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ReorderIcon from '@mui/icons-material/Reorder';
import {
    Box,
    Checkbox,
    Divider,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SorteableItem = ({ columnKeys, handleOnSelectItem, item }) => {
    const { t } = useTranslation();
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: item.name,
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : 1,
        zIndex: isDragging ? 1 : 0,
    };
    return (
        <Box ref={setNodeRef} style={style}>
            <ListItem
                disablePadding
                secondaryAction={
                    <Checkbox
                        checked={item.is_active}
                        disabled={item.required}
                        onChange={(e) =>
                            handleOnSelectItem(item.name, e.target.checked)
                        }
                    />
                }
            >
                <ListItemButton>
                    <ListItemIcon {...attributes} {...listeners}>
                        <ReorderIcon />
                    </ListItemIcon>
                    <ListItemText primary={t(columnKeys[item.name])} />
                </ListItemButton>
            </ListItem>
            <Divider />
        </Box>
    );
};

SorteableItem.propTypes = {
    columnKeys: PropTypes.object,
    handleOnSelectItem: PropTypes.func,
    index: PropTypes.number,
    item: PropTypes.object,
};

export default SorteableItem;
